import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Search = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M17.5 6C11.1487 6 6 11.1487 6 17.5C6 23.8513 11.1487 29 17.5 29C23.8513 29 29 23.8513 29 17.5C29 11.1487 23.8513 6 17.5 6ZM4 17.5C4 10.0442 10.0442 4 17.5 4C24.9558 4 31 10.0442 31 17.5C31 20.868 29.7667 23.9479 27.727 26.3128L35.7071 34.2929C36.0976 34.6834 36.0976 35.3166 35.7071 35.7071C35.3166 36.0976 34.6834 36.0976 34.2929 35.7071L26.3128 27.727C23.9479 29.7667 20.868 31 17.5 31C10.0442 31 4 24.9558 4 17.5Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Search;
